import { render, staticRenderFns } from "./qzcCollegePage.vue?vue&type=template&id=0490e5ad&scoped=true"
import script from "./qzcCollegePage.vue?vue&type=script&lang=js"
export * from "./qzcCollegePage.vue?vue&type=script&lang=js"
import style0 from "./qzcCollegePage.vue?vue&type=style&index=0&id=0490e5ad&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0490e5ad",
  null
  
)

export default component.exports